import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Tabs, Tab, Box } from '@mui/material';
import { useTranslation } from "react-i18next";
// Import your submenu components
import CEOMessage from './Submenus/CEOMessage';
import BoardOfDirectors from './Submenus/BoardOfDirectors';
import Committees from './Submenus/Committees';
import IrenexStatute from './Submenus/IrenexStatute';
import IrenexAtGlance from './Submenus/IrenexAtGlance';
import CodalReports from './Submenus/CodalReports';
import OrganizationChart from './Submenus/OrganizationChart';
import TradesFee from './Submenus/TradesFee';
import SustainabilityReport from './Submenus/SustainabilityReport';
import CorporateGovernance from './Submenus/CorporateGovernance'
import Calendar from './Submenus/Calendar'
import PhysicalMarket from './Submenus/PhysicalMarket'
import PowerMarket from './Submenus/PowerMarket'
import DerivativeMarket from './Submenus/DerivativeMarket'
import OtherTradableMarket from './Submenus/OtherTradableMarket'
import Report from './Submenus/Report'
import Commodities from './Submenus/Commodities'
import Brokers from './Submenus/Brokers'
import MarketMakers from './Submenus/MarketMakers'
import Analyze from './Submenus/Analyze'
import Inventories from './Submenus/Inventories'
import ListingIntroduction from './Submenus/ListingIntroduction'
import SupplyStatementsList from './Submenus/SupplyStatementsList'
import RankingOfListingConsultants from './Submenus/RankingOfListingConsultants'
import Prospectus from './Submenus/Prospectus'
import Producers from './Submenus/Producers'
import DibaSystem from './Submenus/DibaSystem'
import IntegratedEnergyGateway from './Submenus/IntegratedEnergyGateway'
import News from './Submenus/News'
import VisualReports from './Submenus/VisualReports'
import Multimedia from './Submenus/Multimedia'
import SpecializedCommittee from './Submenus/SpecializedCommittee'

const componentMap = {
    CEOMessage,
    BoardOfDirectors,
    Committees,
    IrenexStatute,
    IrenexAtGlance,
    CodalReports,
    OrganizationChart,
    TradesFee,
    SustainabilityReport,
    CorporateGovernance,
    Calendar,
    PhysicalMarket,
    PowerMarket,
    DerivativeMarket,
    OtherTradableMarket,
    Report,
    Commodities,
    Brokers,
    MarketMakers,
    Analyze,
    Inventories,
    ListingIntroduction,
    SupplyStatementsList,
    RankingOfListingConsultants,
    Prospectus,
    Producers,
    DibaSystem,
    IntegratedEnergyGateway,
    News,
    VisualReports,
    Multimedia,
    SpecializedCommittee
};

const MegaMenu = ({ menuItem }) => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    // Filter submenu items based on showOnlyinFA and current language
    const filteredSubmenu = menuItem.submenu.filter(item => {
        if (item.showOnlyinFA) {
            return currentLang === 'fa';
        }
        return true;
    });
    const getDefaultTab = () => {
        if (menuItem.label === 'about_us') {
            const index = filteredSubmenu.findIndex(  // Changed to filteredSubmenu
                item => item.label === 'market_overview'
            );
            return index !== -1 ? index : 0;
        }
        return 0;
    };
    const [activeTab, setActiveTab] = useState(getDefaultTab());
    useEffect(() => {
        setActiveTab(getDefaultTab());
    }, [menuItem, currentLang]);
    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <div className="dropdown-menu megamenu" role="menu">
            <Container>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    {/* Tabs list */}
                    <Box sx={{ minWidth: 180 }}>
                        <Tabs
                            orientation="vertical"
                            value={activeTab}
                            onChange={handleChange}
                            variant="scrollable"
                            className="MegaTabMenu"
                            sx={{
                                '& .MuiTab-root': {
                                    fontFamily: "IranSans",
                                    textTransform: 'none',
                                },
                            }}
                        >
                            {filteredSubmenu.map((submenu, idx) => (  // Changed to filteredSubmenu
                                <Tab key={idx} className="MegaTabMenuButtonWrap"
                                    label={
                                        <div className="MegaTabMenuButton">
                                            <span className="tab-title">{t(submenu.label)}</span>
                                        </div>
                                    }
                                />
                            ))}
                        </Tabs>
                    </Box>

                    {/* Tab content */}
                    <Box sx={{ flexGrow: 1, p: 2 }}>
                        {filteredSubmenu.map((submenu, idx) => {
                            if (idx !== activeTab) return null;
                            const SubmenuComponent = componentMap[submenu.component];
                            return SubmenuComponent ? <SubmenuComponent key={idx} /> : null;
                        })}
                    </Box>
                </Box>
            </Container>
        </div>
    );
};

export default MegaMenu;
